import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { Modal, DeleteModal } from "../Modal";
import { CSVLink } from "react-csv";
import bloodCenterSiteQuery, {
  deleteCenterSite,
} from "../../utils/queries/bloodCenterSiteQuery";
import exportPDF from "../../utils/exportPDF";
import NewSite from "./NewSite";
import { defineRole } from "../../utils/handleAccessRoles";
import { getStorage } from "../../utils/storage";

// eslint-disable-next-line no-unused-vars
let copyData = [];
// eslint-disable-next-line no-unused-vars

class Sites extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selected_data: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  getData = async (isLoading, search) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage, centerId } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await bloodCenterSiteQuery(defaultLanguage, {
        page,
        limit,
        center: centerId,
        ...search,
      });

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].code,
        key: "code",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "name",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/center-sites/${item.center.name}/${item.center._id}/${item.name}/${item._id}`),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
        type: "link",
        onPress: (item) =>
          (window.location.href =
            "/dashboard/centers/" + item.name + "/" + item._id),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].committee_leader,
        key: "committeeLeader.name",
      },
      {
        title: language[this.props.defaultLanguage].contact_number,
        key: "contactNumber",
      },
      {
        title: language[this.props.defaultLanguage].email_address,
        key: "email",
        styles: {
          textTransform: "lowercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].category,
        key: "locationType",
      },
      {
        title: language[this.props.defaultLanguage].is_active,
        key: "available",
      },
      {
        title: language[this.props.defaultLanguage].province,
        key: "address.province",
      },
      {
        title: language[this.props.defaultLanguage].district,
        key: "address.district",
      },
      {
        title: language[this.props.defaultLanguage].sector,
        key: "address.sector",
      },
      {
        title: language[this.props.defaultLanguage].cell,
        key: "address.cell",
      },
      {
        title: language[this.props.defaultLanguage].village,
        key: "address.village",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteCenterSite(
        this.props.defaultLanguage,
        this.state.selected_data._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  downloadExcel = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;

      const { data } = await bloodCenterSiteQuery(defaultLanguage, {
        page,
        limit,
      });

      this.setState({
        isLoading: false,
        csvData: data,
      });

      this.csvDownload.current?.link.click();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  downloadPDF = async () => {
    this.setState({
      isLoading: true,
    });

    const { page, limit } = this.state;
    const { defaultLanguage } = this.props;

    const headers = this.returnTableHeaders();

    const { data } = await bloodCenterSiteQuery(defaultLanguage, {
      page,
      limit,
    });

    this.setState({
      isLoading: false,
    });

    exportPDF("Sites", headers, data);
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      q: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  render() {
    const { add_site, edit_site, delete_site, site, export_, edit, delete_ } =
      language[this.props.defaultLanguage];

    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          // handleSearch={(e) =>
          //   handleSearch(this, {
          //     copyData,
          //     value: e?.target?.value,
          //   })
          // }
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          showAdd={true}
          addButtonText={add_site}
          handleAddPressed={this.handleShowModal.bind(this, "showModal", site)}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.name, item)
          }
          filters={[
            {
              type: "export",
              title: export_,
              button_type: "dropdown",
              icon: "bx bxs-download",
              options: [
                {
                  name: "PDF",
                  onPress: this.downloadPDF.bind(this),
                },
                {
                  name: "CSV",
                  onPress: this.downloadExcel.bind(this),
                },
              ],
            },
          ]}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "Sites",
                operation: "update",
              }),
              name: edit,
              onPress: (item) =>
                this.handleShowModal("showModal", edit_site, item),
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: "Sites",
                operation: "delete",
              }),
              name: delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                delete_site
              ),
            },
          ]}
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewSite
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selected_data.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"Sites" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Sites);
